export default __webpack_public_path__ + "static/media/Ballroll_00151.6f4e87b6.png";